import { useEffect } from "react";

const SEO_DATA = {
  "/": {
    title: "KiddiPlay Club - Find Playmates for Your Family | UK Playdate App",
    description: "Connect with local families for playdates, share babysitting costs, and discover child-friendly activities. Safe, verified community for UK families with kids aged 0-16."
  },
  "/register": {
    title: "Join KiddiPlay Club - Create Your Family Profile | Free Sign Up",
    description: "Sign up free and connect with trusted local families for playdates. Create your family profile, set your preferences, and start finding playmates for your children today."
  },
  "/login": {
    title: "Log In to KiddiPlay Club | Access Your Family Account",
    description: "Log in to your KiddiPlay Club account to find playmates, message families, and organise playdates for your children."
  },
  "/contact": {
    title: "Contact KiddiPlay Club | Get in Touch With Us",
    description: "Have questions about KiddiPlay Club? Contact our friendly team for support, partnership enquiries, or feedback. We're here to help UK families connect."
  },
  "/marketplace": {
    title: "Family Activities & Venues | KiddiPlay Club Marketplace",
    description: "Discover child-friendly activities, soft play centres, swimming lessons, and family venues near you. Find the best places to take your kids in the UK."
  },
  "/sen": {
    title: "SEN Corner - Special Needs Support | KiddiPlay Club",
    description: "Find Changing Places toilets, sensory-friendly venues, and connect with families who understand additional needs. Supporting SEN families across the UK."
  },
  "/community": {
    title: "Family Community - Share Your Adventures | KiddiPlay Club",
    description: "See what families are doing together, share your playdate photos, and get inspired for your next family adventure. Join our supportive community."
  },
  "/privacy": {
    title: "Privacy Policy | KiddiPlay Club",
    description: "Learn how KiddiPlay Club protects your family's data. Our privacy policy explains what information we collect, how we use it, and your rights under UK GDPR."
  },
  "/terms": {
    title: "Terms of Service | KiddiPlay Club",
    description: "Read the terms and conditions for using KiddiPlay Club. Understand your rights and responsibilities as a member of our family community platform."
  },
  "/safeguarding": {
    title: "Safeguarding Policy | KiddiPlay Club",
    description: "KiddiPlay Club's commitment to child safety. Learn about our safeguarding measures, reporting procedures, and how we protect children on our platform."
  },
  "/accessibility": {
    title: "Accessibility Statement | KiddiPlay Club",
    description: "KiddiPlay Club is committed to digital accessibility. Learn about our accessibility features and how we ensure our platform is usable by everyone."
  },
  "/indemnity": {
    title: "Indemnity & Liability | KiddiPlay Club",
    description: "Understand the indemnity terms for using KiddiPlay Club. Information about liability, insurance recommendations, and parental responsibilities."
  },
  "/modern-slavery": {
    title: "Modern Slavery Statement | KiddiPlay Club",
    description: "KiddiPlay Club's commitment to preventing modern slavery and human trafficking. Our statement in accordance with the UK Modern Slavery Act 2015."
  },
  "/discover": {
    title: "Find Local Families | KiddiPlay Club Discovery",
    description: "Discover families near you looking for playdates. Browse profiles, see shared interests, and connect with families in your area."
  },
  "/dashboard": {
    title: "Your Dashboard | KiddiPlay Club",
    description: "Manage your KiddiPlay Club account, view matches, check messages, and organise playdates from your personal dashboard."
  },
  "/profile": {
    title: "Your Family Profile | KiddiPlay Club",
    description: "View and edit your family profile on KiddiPlay Club. Update your children's info, interests, and preferences."
  },
  "/messages": {
    title: "Messages | KiddiPlay Club",
    description: "Chat with other families on KiddiPlay Club. Arrange playdates and coordinate meetups through our secure messaging system."
  },
  "/playdates": {
    title: "Playdate Planner | KiddiPlay Club",
    description: "Plan and manage your family's playdates. Schedule meetups, set reminders, and keep track of your children's social calendar."
  }
};

const DEFAULT_SEO = {
  title: "KiddiPlay Club - Find Playmates for Your Family",
  description: "Connect with local families for playdates, share babysitting costs, and discover child-friendly activities. Safe community for UK families."
};

const SEO = ({ path }) => {
  const seoData = SEO_DATA[path] || DEFAULT_SEO;
  
  useEffect(() => {
    // Update document title
    document.title = seoData.title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = seoData.description;
    
    // Update Open Graph tags
    const updateMeta = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`) || 
                 document.querySelector(`meta[name="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(property.startsWith('og:') ? 'property' : 'name', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    
    updateMeta('og:title', seoData.title);
    updateMeta('og:description', seoData.description);
    updateMeta('og:type', 'website');
    updateMeta('og:site_name', 'KiddiPlay Club');
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', seoData.title);
    updateMeta('twitter:description', seoData.description);
    
    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `https://kiddiplayclub.com${path}`;
  }, [path, seoData]);
  
  return null;
};

export default SEO;
